import React from "react"
import DatalayerPageView from "./DatalayerPageView"
import DatalayerButtonClick from "./DatalayerButtonClick"
import DatalayerAccordionClick from "./DatalayerAccordionClick"
import DatalayerCarouselClick from "./DatalayerCarouselClick"
import DatalayerFooterClick from "./DatalayerFooterClick"
import DatalayerGalleryClick from "./DatalayerGalleryClick"
import DatalayerImageClick from "./DatalayerImageClick"
import DatalayerLanguageSwitch from "./DatalayerLanguageSwitch"
import DatalayerLinkClick from "./DatalayerLinkClick"
import DatalayerNavClick from "./DatalayerNavClick"
import DatalayerTabClick from "./DatalayerTabClick"
import DatalayerMarketoSubmit from "./DatalayerMarketoSubmit"
import DatalayerCognitoSubmit from "./DatalayerCognitoSubmit"
import DatalayerVideo from "./DatalayerVideo"
import DatalayerSearch from "./DatalayerSearch"
import DatalayerBreadcrumbs from "./DatalayerBreadcrumbs"
import DatalayerJumpNavClick from "./DatalayerJumpNavClick"
import DatalayerProductFinder from "./DatalayerProductFinder"
import DatalayerArticlePage from "./DatalayerArticlePage"
import DatalayerBlogDigest from "./DatalayerBlogDigest"
import DatalayerResourceGrid from "./DatalayerResourceGrid"
import DatalayerCalendlySubmit from "./DatalayerCalendlySubmit"
import DatalayerPromoBanner from "./DatalayerPromoBanner"

function Datalayer(props) {
  return (
    <div className="datalayer-gtm hidden hide">
      <DatalayerPageView
        hostname={props?.location?.hostname}
        locale={props?.pageContext?.locale}
        slug={props?.pageContext?.slug}
        siteName={props?.pageContext?.siteName}
        errorCode={props?.errorPageData?.code || props?.errorPage?.code}
        errorMessage={
          props?.errorPageData?.message || props?.errorPage?.message
        }
        videoProgress={props?.videoProgress}
      />
      <DatalayerButtonClick
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerAccordionClick
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerCarouselClick
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerFooterClick
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerGalleryClick
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerImageClick
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerLanguageSwitch
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerLinkClick
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerNavClick
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerTabClick
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerMarketoSubmit
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerCognitoSubmit
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerVideo
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
        videoProgress={props.videoProgress}
      />
      <DatalayerSearch
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerProductFinder
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerBreadcrumbs />
      <DatalayerJumpNavClick
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerArticlePage
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
        articleWrapperRef={props.articleWrapperRef}
      />
      <DatalayerBlogDigest
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerResourceGrid
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerPromoBanner
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
      <DatalayerCalendlySubmit
        data={props.data}
        pageContext={props.pageContext}
        location={props.location}
      />
    </div>
  )
}

export default Datalayer
